import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

export class CustomMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
    // console.log("CustomMissingTranslationHandler")
  const defaultText = (params.interpolateParams as { defaultValue?: string })?.defaultValue || '';
  // console.log(params, defaultText)
    return defaultText;
  }
}

